import styled from 'styled-components';

export const StepWrapper = styled.div`
  height: calc(100% - 200px);
  overflow: auto;
  position: absolute;
  top: 70px;
  display: ${(props) => (props.open ? 'block' : 'none')};
`;
